<!-- Header of Admin Panel -->
<app-header></app-header>
<!-- Sidebar of Admin Panel -->
<section class="private-layout section--top">
	<div class="container-fluid">
		<div class="row flex-nowrap">
			<div class="col-auto px-0">
				<app-admin-sidebar></app-admin-sidebar>
			</div>
			<div class="col-auto flex-fill px-0">
				<!-- Admin Content-->
				<router-outlet></router-outlet>
			</div>
		</div>
	</div>
</section>
<app-footer *ngIf="isFooter"></app-footer>